import React, { useEffect, useState } from "react";
import backendConfig from "../../../../config/backend";
import { GKPresetColors } from "../MediaLibrary/EditModal/LeftSidebar/EditTab";

export default React.memo(function PlayerImage({ player, presetClass = "gray", gkPreset = GKPresetColors.red, className, id, alt, onClick, }) {
    const [dynamicClassName, setDynamicClassName] = useState(className);
    const [error, setError] = useState(false);
    let presetClassName = presetClass;
    const handleError = (currentTarget) => {
        if (currentTarget.src.includes("?fallback=true")) {
            // If fallback has already been applied, do nothing
            setError(false)
            return;
        }

        const originalSrc = currentTarget.src;

        // Only attempt to switch to SVG for images in /dynamic/team/ directory
        if (!originalSrc.endsWith(".svg") && originalSrc.endsWith(".png")) {
            // Switch to SVG and update class name
            currentTarget.src = originalSrc.replace(".png", ".svg");
            setDynamicClassName(`${className} svg-logo`); // Add extra class for SVG
            setError(false);
        } else {
            // Apply existing fallback logic only after trying with .svg
            currentTarget.onerror = null; // prevents looping

            // currentTarget.src = `/images/players/x4qyxhfr2vi007sazoqe5vit.png`;
            className = `${className}`;
            // Add a query parameter to mark that fallback has been applied
            currentTarget.src += "?fallback=true";

            // Reset class name to original if SVG fails
            setDynamicClassName(className);
            setError(true);
        }
    };
    useEffect(() => {

        setError(false)

    }, [presetClass, gkPreset])
    if (!player) return null;
    const { id: playerId } = player;
    const isGoalKeeper = player.position === 'Goalkeeper';
    if (presetClassName === 'gray') {
        presetClassName = 'white'
    }
    if (isGoalKeeper) {
        presetClassName = 'red';
        if (gkPreset === GKPresetColors.red) presetClassName = 'red'
        if (gkPreset === GKPresetColors.black) presetClassName = 'black'
        if (gkPreset === GKPresetColors.purple) presetClassName = 'purple'
        if (gkPreset === GKPresetColors.green) presetClassName = 'green'
    }
    const baseUrl = backendConfig.apiUrl;
    const posValue = player[`${presetClassName}Pos`];
    // 0 is a deliberate sentinel (set by the lineup checkbox shuffle logic)
    // meaning no photo satisfies the current smiling filter for this jersey
    // — don't fall back to position 1, which could be a smiling photo.
    if (posValue === 0) return null;
    const pos = posValue || 1;
    const src = `${baseUrl}/upload/fcbPlayers/${presetClassName}/${playerId}_${pos}.webp`;
    if (error) return null;
    return (
        <img
            src={src}
            id={id}
            className={dynamicClassName}
            alt={alt}
            onError={({ currentTarget }) => handleError(currentTarget)}
            onClick={onClick}
        />
    );
});
